<template>
  <div id="page-report">
    <div class="main">
      <header class="header">
        <!-- <span
          class="tabItem"
          :class="{'tabItem-selected':isAutoReportSelected}"
          @click="handleClickTab(0)"
        >自动报告</span>-->
        <span
            class="tabItem"
            :class="{'tabItem-selected':isManualReportSelected}"
            @click="handleClickTab(1)"
        >人工报告</span>
      </header>
      <div class="content content-autoReport" v-show="isAutoReportSelected">
        <aside class="aside">
          <h2 class="jobList-title">任务列表</h2>
          <ul class="jobList">
            <li
                class="jobListItem"
                :class="{'jobListItem-selected':false}"
                v-for="item in jobList"
                :key="item.id"
            >{{item.jobName}} ({{item.jobNum}})</li>
          </ul>
        </aside>
        <article class="article">
          <section class="section-up">
            <div class="reportName-wrap">
              <label for="input-reportName" class="inputLabel">报告名称</label>
              <input type="text" id="input-reportName" placeholder="请输入报告名" v-model="reportName" />
            </div>
            <div class="reportCycle-wrap">
              <label for="input-reportCycle" class="inputLabel">报告周期</label>
              <DatePicker
                  type="daterange"
                  id="input-reportCycle"
                  @on-ok="confirmDatePicker"
                  v-model="dateRange"
                  placement="bottom-end"
                  placeholder="请选择报告周期"
                  confirm
                  split-panels
              ></DatePicker>
              <div class="btn-generateReport">
                <span class="btn-generateReport-title">生成报告</span>
              </div>
            </div>
          </section>
          <section class="section-down">
            <table class="table-report" cellspacing="0" cellpadding="0" border="0">
              <thead class="table-head">
              <tr align="center">
                <th>报告名称</th>
                <th>生成日期</th>
                <th>操作</th>
              </tr>
              </thead>
              <tbody class="table-body">
              <tr v-for="item in tableReport_list" :key="item.id">
                <td>{{item.name}}</td>
                <td>{{item.date}}</td>
                <td>
                  <div class="table-operations">
                      <span
                          class="btn-operation btn-check"
                          @click="checkReport(item.id)"
                      >查看报告</span>
                    <span class="btn-operation btn-download" @click="downloadReport(item.id)">下载报告</span>
                    <span
                        class="btn-operation btn-del"
                        @click="deleteReport(item.id)"
                        :class="{'disabled':!enable_delete}"
                    >删除报告</span>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </section>
        </article>
      </div>
      <div class="content content-manualReport" v-show="isManualReportSelected">
        <div class="btn-uploadReport-wrap">
          <span
              class="btn-uploadReport"
              @click="clickUploadFile"
              :class="{'disabled':!enable_upload}"
          >上传报告</span>
        </div>
        <table class="table-report" cellspacing="0" cellpadding="0" border="0">
          <thead class="table-head">
          <tr align="center">
            <th>报告名称</th>
            <th>生成日期</th>
            <th>所属任务</th>
            <th>操作</th>
          </tr>
          </thead>
          <tbody class="table-body">
          <tr v-for="item in tableReport_list" :key="item.id">
            <td>{{item.name}}</td>
            <td>{{item.date}}</td>
            <td>{{item.jobName}}</td>
            <td>
              <div class="table-operations">
                <span class="btn-operation btn-check" @click="checkReport(item.id)">查看报告</span>
                <span class="btn-operation btn-download" @click="downloadReport(item.id)">下载报告</span>
                <span
                    class="btn-operation btn-del"
                    @click="deleteReport(item.id)"
                    :class="{'disabled':!enable_delete}"
                >删除报告</span>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
        <div class="page-wrapper" v-show="isShowPage" style="margin:30px">
          <Page
              :total="report_total"
              :page-size="pageSize"
              :current="currentPage"
              @on-change="changePage"
              show-total
              class="page"
          />
        </div>
      </div>
    </div>
    <!-- 上传报告模态框 ------------------------------------------------------------------>
    <div class="modal-uploadTask-mask" v-show="isShowModalUpload">
      <div class="modal-uploadTask">
        <div class="icon-close-wrap">
          <span class="icon-close" @click="closeModalUpload"></span>
        </div>
        <div class="selectJob-wrap">
          <label class="selectJob-label">选择任务</label>
          <Select
              v-model="modalData.jobIdSelected"
              style="width:192px; float:left;"
              placeholder="请选择任务"
          >
            <Option
                v-for="item in modalData.jobList"
                :value="item.value"
                :key="item.value"
            >{{ item.label }}</Option>
          </Select>
        </div>
        <div class="selectFile-wrap">
          <label class="selectFile-label">生成日期</label>
          <DatePicker
            type="date"
            v-model="modalData.reportDate"
            placement="bottom-end"
            placeholder="请选择生成日期"            style="width: 192px; float: left;"
            format="yyyyMMdd"
          ></DatePicker>
        </div>
        <div class="selectFile-wrap">
          <label class="selectFile-label">选择文件</label>
          <input
              type="text"
              v-model="modalData.fileName"
              readonly
              class="selectFile-fileName"
              v-if="modalData.file"
              placeholder="未选择文件"
          />
          <Upload
              action
              ref="upload"
              :show-upload-list="false"
              :format="fileFormat"
              :before-upload="handleBeforeUpload"
              style="float:left"
          >
            <Button type="default" icon="md-checkbox-outline" style="height:32px">选择文件</Button>
          </Upload>
        </div>
        <div class="btn-upload-wrap">
          <div class="btn-upload" @click="uploadFile">上传</div>
        </div>
      </div>
    </div>
    <!-- loading动画 --------------------------------------------------------------------------->
    <loading :isLoading="isUploading||isLoadingReportInfo||isGettingJobList||isDeletingReport"></loading>
  </div>
</template>

<script>
export default {
  data() {
    return {
      //是否选中<自动报告>tab
      isAutoReportSelected: false,
      //是否选中<人工报告>tab
      isManualReportSelected: true,
      //是否显示<上传报告>模态框
      isShowModalUpload: false,
      //是否正在上传文件
      isUploading: false,
      //是否正在获取任务id
      isGettingJobList: false,
      //是否正在获取报告列表数据
      isLoadingReportInfo: false,
      //是否正在删除报告
      isDeletingReport: false,
      report_total: 0,
      //当前展示的页码
      currentPage: 1,
      pageSize: 10,
      //是否展示分页：没有数据时隐藏
      isShowPage: true,
      //任务列表数据
      jobList: [
        {
          id: "1",
          jobName: "易通贷",
          jobNum: 271
        },
        {
          id: "2",
          jobName: "抱财网",
          jobNum: 169
        },
        {
          id: "3",
          jobName: "团贷网",
          jobNum: 372
        }
      ],
      //<报告名称>输入框数据
      reportName: "",
      //<报告周期>日期选择器数据
      dateRange: [],
      //表格数据
      tableReport_list: [],
      //<上传报告模态框>数据
      modalData: {
        jobIdSelected: "", //已选任务id
        //可选任务list
        jobList: [],
        reportDate: "", //已选报告生成日期
        fileName: "", //已选文件的名称
        file: null //已选文件
      },
      //<上传报告模态框>可上传的文件格式
      fileFormat: ["docx", "doc", "xls", "xlsx", "ppt", "pptx", "pdf"],
      //是否拥有<上传报告>权限
      enable_upload: false,
      //是否拥有<删除报告>权限
      enable_delete: false
    };
  },
  created() {
    //获取报告列表数据
    this.getReportListInfo();
  },
  mounted() {
    this.getAuthorities();
  },
  methods: {
    //获取上传报告和删除报告权限
    getAuthorities() {
      let authorites = this.getLocalStorage("authorities").split(",");
      this.enable_upload = authorites.includes("report_upload");
      this.enable_delete = authorites.includes("report_delete");
    },
    changePage(page) {
      //更新页码
      this.currentPage =  page;
      //查询舆情列表数据
      this.getReportListInfo();
    },
    //获取报告列表数据
    getReportListInfo() {
      if (this.isLoadingReportInfo) return;
      this.isLoadingReportInfo = true;
      this.$ajax({
        method: "get",
        url: "./report/filelist",
        params: {
          "pageNo": this.currentPage,
          "pageSize": this.pageSize
        }
      })
          .then(res => {
            this.isLoadingReportInfo = false;
            if (res.data.success) {
              let reportList = res.data.data.data || [];
              this.report_total = res.data.data.total;
              //先清空
              this.tableReport_list = [];
              for (let i = 0; i < reportList.length; i++) {
                let item = {
                  id: reportList[i].id,
                  name: reportList[i].reportName,
                  reportUrl: reportList[i].reportUrl,
                  date: reportList[i].uploadTime,
                  jobName: reportList[i].jobName,
                  jobId: reportList[i].jobId
                };
                this.tableReport_list.push(item);
              }
            } else {
              if (res.data.code !== 405) {
                this.$Message.error("服务器错误");
              }
            }
          })
          .catch(err => {
            this.$Message.error("服务器错误");
            console.log(err);
          });
    },
    //点击tab切换<自动报告>和<人工报告>
    handleClickTab(param) {
      if (param === 0) {
        this.isAutoReportSelected = true;
        this.isManualReportSelected = false;
      } else {
        this.isAutoReportSelected = false;
        this.isManualReportSelected = true;
      }
    },
    //点击datePicker确认按钮
    confirmDatePicker() {},
    //点击表格<查看报告>按钮
    checkReport(url) {
      if (this.isAutoReportSelected) {
      } else {
        window.open('./report/preview?id='+url);
      }
    },
    //点击<上传>报告按钮，获取可选任务列表
    clickUploadFile() {
      if (this.isGettingJobList) return;
      if (!this.enable_upload) {
        this.$Message.error("未获得该功能权限");
        return;
      }
      this.isGettingJobList = true;
      this.$ajax({
        method: "get",
        url: "./report/jobList"
      })
          .then(res => {
            this.isGettingJobList = false;
            //如果存在res.data
            if (res.data.success) {
              this.isShowModalUpload = true;
              let data = res.data.data || [];
              //先清空
              this.modalData.jobList = [];
              this.modalData.jobList = data.map(item => {
                let obj = {
                  value: item.jobId,
                  label: item.jobName
                };
                return obj;
              });
            } else {
              if (res.data.code !== 405) {
                this.$Message.error("服务器错误");
              }
            }
          })
          .catch(err => {
            this.$Message.error("服务器错误");
            console.log(err);
          });
    },
    //点击表格<下载报告>按钮
    downloadReport(id) {
      if (this.isAutoReportSelected) {
      } else {
        let url = './report/download?id=' + id;
        window.location.href = url
      }
    },
    //点击表格<删除报告>按钮
    deleteReport(id) {
      if (this.isAutoReportSelected) return;
      if (!this.enable_delete) {
        this.$Message.error("未获得该功能权限");
        return;
      }
      if (this.isDeletingReport) return;
      this.$Modal.confirm({
        title: "删除报告",
        content: "<p>是否删除该报告？</p>",
        onOk: () => {
          this.isDeletingReport = true;
          this.$ajax({
            method: "get",
            url: "./report/filedelete",
            params: {
              id: id
            }
          })
              .then(res => {
                this.isDeletingReport = false;
                if (res.data.success) {
                  this.$Message.success("报告删除成功");
                  //刷新报告列表
                  this.getReportListInfo();
                } else {
                  if (res.data.code !== 405) {
                    this.$Message.error("服务器错误");
                  }
                }
              })
              .catch(err => {
                this.$Message.error("服务器错误");
                console.log(err);
              });
        },
        onCancel: () => {}
      });
    },
    //关闭<上传报告模态框>
    closeModalUpload() {
      //清空模态框数据
      this.modalData.jobIdSelected = "";
      this.modalData.fileName = "";
      this.modalData.reportDate = null;
      this.modalData.file = null;
      //关闭模态框
      this.isShowModalUpload = false;
    },
    //<上传报告模态框>上传文件之前处理函数
    handleBeforeUpload(file) {
      //判断文件格式是否为csv
      let fileName = file.name;
      let index1 = fileName.lastIndexOf(".");
      let index2 = fileName.length;
      let suffix = fileName.substr(index1 + 1, index2);
      if (!this.fileFormat.includes(suffix)) {
        this.$Message.error({
          content: "上传文件格式只能是word/excel/ppt/pdf，请重新上传！",
          duration: 3
        });
        return false;
      } else {
        this.modalData.file = file;
        this.modalData.fileName = file.name;
        //阻止默认上传
        return false;
      }
    },
    //点击<上传报告模态框>上传按钮
    uploadFile() {
      if (this.modalData.file === null || !this.modalData.jobIdSelected) {
        this.$Message.error("请确保参数完整");
      } else {
        if (this.isUploading) return;
        this.isUploading = true;
        let formdata = new FormData();
        formdata.append("jobId", this.modalData.jobIdSelected);
        let reportDateStr = "";
        if (this.modalData.reportDate instanceof Date) {
          const year = this.modalData.reportDate.getFullYear();
          const month = String(this.modalData.reportDate.getMonth() + 1).padStart(2, '0');
          const day = String(this.modalData.reportDate.getDate()).padStart(2, '0');
          reportDateStr = `${year}${month}${day}`;
        } else {
          reportDateStr = this.modalData.reportDate || "";
        }
        formdata.append("reportDate", reportDateStr);
        formdata.append("file", this.modalData.file);
        this.$ajax({
          method: "post",
          url: "./report/fileupload",
          data: formdata
        })
            .then(res => {
              this.isUploading = false;
              if (res.data.success) {
                this.$Message.success("报告上传成功");
                this.closeModalUpload();
                this.getReportListInfo();
              } else {
                if (res.data.code !== 405) {
                  this.$Message.error("服务器错误");
                }
              }
            })
            .catch(err => {
              this.$Message.error("服务器错误");

              console.log(err);
            });
      }
    }
  }
};
</script>

<style lang="less">
#page-report {
  ::-webkit-input-placeholder {
    /* WebKit browsers */
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #d8d9dc;
    letter-spacing: -0.29px;
  }
  :-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #d8d9dc;
    letter-spacing: -0.29px;
  }
  ::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #d8d9dc;
    letter-spacing: -0.29px;
  }
  :-ms-input-placeholder {
    /* Internet Explorer 10+ */
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #d8d9dc;
    letter-spacing: -0.29px;
  }
  .main {
    width: 1160px;
    margin: 0 auto;
    margin-top: 20px;
    background-color: #fff;
    box-sizing: border-box;
    min-height: 1040px;
    padding: 0 80px;
    box-shadow: 0 0 16px 0 #f3f4f7;
    .header {
      height: 80px;
      box-sizing: border-box;
      padding-top: 20px;
      border-bottom: 1px solid #efeff4;
      .tabItem {
        float: left;
        height: 60px;
        line-height: 60px;
        font-family: PingFangSC-Medium;
        font-size: 18px;
        color: #333333;
        margin-right: 75px;
        cursor: pointer;
      }
      .tabItem-selected {
        border-bottom: 3px solid #415af6;
      }
    }
    .content-autoReport {
      overflow: hidden;
      width: 997;
      padding-top: 35px;
      box-sizing: border-box;
      .aside {
        float: left;
        height: 894px;
        width: 200px;
        box-sizing: border-box;
        padding-top: 30px;
        border: 1px solid #efeff4;
        .jobList-title {
          text-align: center;
          font-family: PingFangSC-Medium;
          font-size: 20px;
          color: #333333;
          letter-spacing: -0.41px;
          text-align: left;
          padding-left: 30px;
        }
        .jobList {
          margin-top: 20px;
          .jobListItem {
            font-family: PingFangSC-Regular;
            font-size: 18px;
            text-align: left;
            color: #333333;
            letter-spacing: -0.37px;
            height: 45px;
            line-height: 45px;
            padding-left: 30px;
            cursor: pointer;
            transition: all 0.2s ease-in;
          }
          .jobListItem-selected {
            background-color: rgb(214, 217, 247);
            font-family: PingFangSC-Regular;
            font-size: 18px;
            color: #415af6;
            letter-spacing: -0.37px;
          }
        }
      }
      .article {
        float: right;
        overflow: hidden;
        width: 798px;
        .section-up {
          .reportName-wrap {
            height: 40px;
            .inputLabel {
              margin-left: 40px;
              font-family: PingFangSC-Regular;
              font-size: 18px;
              color: #333333;
              letter-spacing: -0.37px;
              float: left;
              line-height: 40px;
            }
            #input-reportName {
              float: left;
              margin-left: 25px;
              outline: none;
              border: 1px solid #d8d9dc;
              padding-left: 10px;
              border-radius: 4px;
              height: 40px;
              line-height: 38px;
              width: 317px;
              font-family: PingFangSC-Regular;
              font-size: 16px;
              letter-spacing: -0.33px;
            }
          }
          .reportCycle-wrap {
            margin-top: 20px;
            height: 40px;
            .inputLabel {
              margin-left: 40px;
              font-family: PingFangSC-Regular;
              font-size: 18px;
              color: #333333;
              letter-spacing: -0.37px;
              float: left;
              line-height: 40px;
            }
            #input-reportCycle {
              float: left;
              margin-left: 25px;
              height: 40px;
              line-height: 38px;
              width: 317px;
              font-family: PingFangSC-Regular;
              font-size: 16px;
              letter-spacing: -0.33px;
              input {
                height: 40px;
              }
              .ivu-icon {
                line-height: 40px;
              }
              .ivu-picker-panel-body {
                line-height: 0.8;
                font-size: 12px;
              }
            }
            .btn-generateReport {
              float: right;
              background: #415af6;
              border-radius: 4px;
              height: 40px;
              width: 153px;
              font-family: PingFangSC-Regular;
              font-size: 16px;
              color: #ffffff;
              letter-spacing: -0.33px;
              line-height: 40px;
              position: relative;
              cursor: pointer;
              .btn-generateReport-title {
                line-height: 40px;
                display: inline-block;
                position: absolute;
                left: 55px;
              }
              &::before {
                content: "";
                display: inline-block;
                position: absolute;
                height: 15px;
                width: 12px;
                top: 50%;
                left: 35px;
                transform: translate(0, -50%);
                background: url("https://static.rong360.com/upload/png/48/15/481512a8ab72d9165e10d1978feb75d8.png");
                background-repeat: no-repeat;
                background-position: center;
                background-size: 100% 100%;
              }
              &:hover {
                opacity: 0.8;
              }
            }
          }
        }
        .section-down {
          margin-top: 50px;
          .table-report {
            margin: 0 auto;
            width: 757px;
            .table-head {
              line-height: 50px;
              background-color: #f8fafe;
              font-family: PingFangSC-Medium;
              font-size: 14px;
              color: #333333;
              letter-spacing: 0;
              tr {
                th {
                  border-top: 1px solid #efeff4;
                }
                th:first-of-type {
                  border-left: 1px solid #efeff4;
                }
                th:last-of-type {
                  padding-left: 40px;
                  text-align: left;
                  border-right: 1px solid #efeff4;
                }
              }
            }
            .table-body {
              tr {
                border-bottom: 1px solid #efeff4;
                transition: all 0.3s ease-in;
                &:hover {
                  background-color: #f0f8ff;
                }
                td {
                  font-family: PingFangSC-Regular;
                  font-size: 14px;
                  color: #333333;
                  letter-spacing: 0;
                  line-height: 50px;
                  border-bottom: 1px solid #efeff4;
                }
                td:first-of-type {
                  border-left: 1px solid #efeff4;
                }
                td:last-of-type {
                  border-right: 1px solid #efeff4;
                }
              }
              .table-operations {
                display: flex;
                justify-content: space-around;
                .btn-check {
                  &::before {
                    display: inline-block;
                    content: "";
                    height: 13px;
                    width: 17px;
                    background: url("https://static.rong360.com/upload/png/c8/e0/c8e0faeac2676b957831109f91a961f3.png");
                    background-position: center;
                    background-repeat: no-repeat;
                    background-size: 100% 100%;
                    vertical-align: middle;
                  }
                }
                .btn-download {
                  &::before {
                    display: inline-block;
                    content: "";
                    height: 16px;
                    width: 16px;
                    background: url("https://static.rong360.com/upload/png/da/1d/da1d7afa537c2c3fba10a9898c493dc6.png");
                    background-position: center;
                    background-repeat: no-repeat;
                    background-size: 100% 100%;
                    vertical-align: middle;
                  }
                }
                .btn-del {
                  &::before {
                    display: inline-block;
                    content: "";
                    height: 16px;
                    width: 16px;
                    background: url("https://static.rong360.com/upload/png/6a/ed/6aed3bf6b9d7fe249a4baa5bf3e058f3.png");
                    background-position: center;
                    background-repeat: no-repeat;
                    background-size: 100% 100%;
                    vertical-align: middle;
                  }
                  &.disabled {
                    cursor: not-allowed;
                    color: #999;
                    &::before {
                      opacity: 0.5;
                    }
                  }
                }
                .btn-operation {
                  cursor: pointer;
                  &::before {
                    margin-right: 5px;
                    margin-top: -2px;
                  }
                }
              }
            }
          }
        }
      }
    }
    .content-manualReport {
      .btn-uploadReport-wrap {
        height: 73px;
        position: relative;
        .btn-uploadReport {
          display: inline-block;
          position: absolute;
          bottom: 0;
          right: 0;
          height: 40px;
          line-height: 40px;
          width: 153px;
          border-radius: 4px;
          background-color: #415af6;
          font-family: PingFangSC-Regular;
          font-size: 16px;
          color: #ffffff;
          letter-spacing: -0.33px;
          text-align: left;
          padding-left: 55px;
          cursor: pointer;
          &:hover {
            opacity: 0.8;
          }
          &::before {
            content: "";
            display: inline-block;
            position: absolute;
            height: 17px;
            width: 17px;
            top: 50%;
            left: 30px;
            transform: translateY(-50%);
            background: url("https://static.rong360.com/upload/png/72/54/7254e8f0016dc1be1e583cfd092aeec2.png");
            background-position: center;
            background-repeat: no-repeat;
            background-size: 100% 100%;
            vertical-align: middle;
          }
          &.disabled {
            opacity: 0.7;
            cursor: not-allowed;
          }
        }
      }
      .table-report {
        margin: 0 auto;
        margin-top: 15px;
        width: 997px;
        .table-head {
          line-height: 50px;
          background-color: #f8fafe;
          font-family: PingFangSC-Medium;
          font-size: 14px;
          color: #333333;
          letter-spacing: 0;
          tr {
            th {
              border-top: 1px solid #efeff4;
            }
            th:first-of-type {
              width: 300px;
              border-left: 1px solid #efeff4;
            }
            th:last-of-type {
              padding-left: 50px;
              text-align: left;
              border-right: 1px solid #efeff4;
            }
          }
        }
        .table-body {
          tr {
            border-bottom: 1px solid #efeff4;
            transition: all 0.3s ease-in;
            &:hover {
              background-color: #f0f8ff;
            }
            td {
              font-family: PingFangSC-Regular;
              font-size: 14px;
              color: #333333;
              letter-spacing: 0;
              line-height: 50px;
              border-bottom: 1px solid #efeff4;
            }
            td:first-of-type {
              padding-left: 10px;
              max-width: 300px;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              border-left: 1px solid #efeff4;
              text-align: left;
            }
            td:last-of-type {
              border-right: 1px solid #efeff4;
            }
          }

          .table-operations {
            display: flex;
            justify-content: space-around;
            .btn-check {
              &::before {
                display: inline-block;
                content: "";
                height: 13px;
                width: 17px;
                background: url("https://static.rong360.com/upload/png/40/64/4064022a25b5a284366abb450aa0b5aa.png");
                background-position: center;
                background-repeat: no-repeat;
                background-size: 100% 100%;
                vertical-align: middle;
              }
            }
            .btn-download {
              &::before {
                display: inline-block;
                content: "";
                height: 16px;
                width: 16px;
                background: url("https://static.rong360.com/upload/png/8b/f1/8bf169b233e3d778c0a7d82171a5d0bf.png");
                background-position: center;
                background-repeat: no-repeat;
                background-size: 100% 100%;
                vertical-align: middle;
              }
            }
            .btn-del {
              &::before {
                display: inline-block;
                content: "";
                height: 16px;
                width: 16px;
                background: url("https://static.rong360.com/upload/png/76/d6/76d6c7c9a23ca15ae4b55266f9fe7cf9.png");
                background-position: center;
                background-repeat: no-repeat;
                background-size: 100% 100%;
                vertical-align: middle;
              }
              &.disabled {
                cursor: not-allowed;
                color: #999;
                &::before {
                  opacity: 0.5;
                }
              }
            }
            .btn-operation {
              cursor: pointer;
              &::before {
                margin-right: 5px;
                margin-top: -2px;
              }
            }
          }
        }
      }
    }
  }
  .modal-uploadTask-mask {
    position: fixed;
    height: 100%;
    width: 100%;
    z-index: 999;
    top: 0;
    left: 0;
    transition: all 0.3s ease-in;
    .modal-uploadTask {
      position: absolute;
      left: 50%;
      top: 50%;
      width: 500px;
      height: 284px;
      transform: translate(-50%, -50%);
      background: #fff;
      box-shadow: 0 0 30px 0 #c8c7cc;
      border-radius: 4px;
      .icon-close-wrap {
        position: relative;
        height: 56px;
        .icon-close {
          position: absolute;
          right: 28px;
          top: 50%;
          transform: translate(0, -50%);
          height: 16px;
          width: 16px;
          line-height: 60px;
          background: url("https://static.rong360.com/upload/png/6c/9c/6c9c09640ef8a6a010b1f3b69b0f94bf.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;
          background-position: center;
          cursor: pointer;
          &:hover {
            opacity: 0.8;
          }
        }
      }
      .selectJob-wrap {
        height: 32px;
        padding-left: 25px;
        overflow: hidden;
        .selectJob-label {
          float: left;
          line-height: 30px;
          font-family: PingFangSC-Regular;
          font-size: 16px;
          color: #666666;
          letter-spacing: -0.33px;
          margin-right: 15px;
        }
      }
      .selectFile-wrap {
        height: 32px;
        padding-left: 25px;
        overflow: hidden;
        margin-top: 15px;
        .selectFile-label {
          float: left;
          line-height: 30px;
          font-family: PingFangSC-Regular;
          font-size: 16px;
          color: #666666;
          letter-spacing: -0.33px;
          margin-right: 15px;
        }
        .selectFile-fileName {
          float: left;
          padding-left: 10px;
          height: 32px;
          outline: none;
          border-radius: 4px;
          border: 1px solid #d8d9dc;
          line-height: 30px;
          width: 250px;
          margin-right: 15px;
        }
      }
      .btn-upload-wrap {
        height: 40px;
        margin-top: 55px;
        padding-left: 100px;
        .btn-upload {
          height: 40px;
          line-height: 40px;
          width: 153px;
          font-family: PingFangSC-Regular;
          font-size: 16px;
          color: #ffffff;
          letter-spacing: -0.33px;
          background-color: #415af6;
          border-radius: 4px;
          cursor: pointer;
          &:hover {
            opacity: 0.8;
          }
        }
      }
    }
  }
}
</style>
